import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const csrfToken = this.getCookie('csrf_');
        if (csrfToken && request.method !== 'GET') {
            request = request.clone({
                setHeaders: {
                    'X-Csrf-Token': csrfToken,
                }
            });
        }
        return next.handle(request);
    }

    getCookie(name: string): string | null {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
        return null;
    }
}
